export default "__VITE_ASSET__CqGuEBHc__"